import { render, staticRenderFns } from "./DrawerContent.vue?vue&type=template&id=6b245400&scoped=true&"
import script from "./DrawerContent.vue?vue&type=script&lang=js&"
export * from "./DrawerContent.vue?vue&type=script&lang=js&"
import style0 from "./DrawerContent.vue?vue&type=style&index=0&id=6b245400&scoped=true&lang=css&"
import style1 from "./DrawerContent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b245400",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VList,VListItem,VListItemGroup,VTab,VTabs,VTabsSlider,VTextField})
